import { render, staticRenderFns } from "./ProjectNew.vue?vue&type=template&id=1398bba7&scoped=true"
import script from "./ProjectNew.vue?vue&type=script&lang=ts"
export * from "./ProjectNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectNew.vue?vue&type=style&index=0&id=1398bba7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398bba7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1398bba7')) {
      api.createRecord('1398bba7', component.options)
    } else {
      api.reload('1398bba7', component.options)
    }
    module.hot.accept("./ProjectNew.vue?vue&type=template&id=1398bba7&scoped=true", function () {
      api.rerender('1398bba7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/ProjectNew.vue"
export default component.exports